import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

import './SignupDialog.css';

type SignUpDialogType = {
  showSignupPopup: boolean;
  setShowSignupPopup: (arg: boolean) => void;
  setIsSignupPopupOpen: (arg: boolean) => void;
};

function SignupLoginDialog({
  showSignupPopup,
  setIsSignupPopupOpen,
}: SignUpDialogType) {
  const [open, setOpen] = React.useState(showSignupPopup || false);
  const handleClose = () => {
    setOpen(false);

    if (setIsSignupPopupOpen) {
      setIsSignupPopupOpen(false);
    }
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setOpen(true);
    }, 600000); // 10 minutes in milliseconds

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>
        Jai Bhim. Please consider signing up to enjoy all features.
      </DialogTitle>
      <div className="SignupLoginDialogContainer">
        {/* Added target and rel props to this Link */}
        <Link to="/signup" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" onClick={handleClose}>
            Sign-up
          </Button>
        </Link>
        <Typography>Already have an account? </Typography>
        {/* Added target and rel props to this Link */}
        <Link to="/login" target="_blank" rel="noopener noreferrer">
          <Button color="info" onClick={handleClose}>
            Login
          </Button>
        </Link>
      </div>
    </Dialog>
  );
}

export default SignupLoginDialog;
